// extracted by mini-css-extract-plugin
export default {"header":"App_header__fhC8n","logo":"App_logo__7Edbg","watermark":"App_watermark__KfFZP","title":"App_title__YS7Xx"};